module.exports = __webpack_public_path__ + "img/sigh_3kl.c56363ad.jpg";